export default function verifyProfilesVision(perfisParaVerificar = []) {
  const userProfiles =
    JSON.parse(localStorage.getItem("userProfilesVision")) ||
    JSON.parse(localStorage.getItem("userProfiles")) ||
    [];

  if (!Array.isArray(perfisParaVerificar) || perfisParaVerificar.length === 0) {
    return false;
  }

  return userProfiles.some((profile) =>
    perfisParaVerificar.includes(profile.NomePerfil)
  );
}
